const get = require('lodash.get');

const elEntityImg = function(ConfigEnvironment) {
  "ngInject";

  const envCdn = ConfigEnvironment.getConfiguration('env_cdn');

  return {
    restrict: 'A',
    link(scope, el, attrs) {
      function render(gb_cause_id) {
        const randomString =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        const src = `${envCdn}greenback/entities/${gb_cause_id}/0/logo?${randomString}`;
        scope.src = src;
      }

      attrs.$observe('elEntityImg', (gb_cause_id) => {
        render(gb_cause_id);
      }); 
    }
  }
};

export default elEntityImg;



// WEBPACK FOOTER //
// ./js/containers/core/directives/elEntityImg.js